/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Sch_Cat_Started_HintInputs */

const en_sch_cat_started_hint = /** @type {(inputs: Sch_Cat_Started_HintInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Work in progress.`)
};

const de_sch_cat_started_hint = /** @type {(inputs: Sch_Cat_Started_HintInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Die Arbeit läuft.`)
};

/**
* | output |
* | --- |
* | "Work in progress." |
*
* @param {Sch_Cat_Started_HintInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const sch_cat_started_hint = /** @type {((inputs?: Sch_Cat_Started_HintInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Sch_Cat_Started_HintInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return de_sch_cat_started_hint(inputs)
	return en_sch_cat_started_hint(inputs)
});